import Vue from 'vue'
import VueRouter  from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import SignUp from '../views/SignUp.vue'
import CreateEvent from '../views/CreateEvent.vue'
import EventList from '../views/EventList.vue'
import ExerciseVoice from '../views/ExerciseVoice.vue'
import Transitions from '../views/Transitions.vue'
import ClassBuilder from '../views/ClassBuilder.vue'
import Uploader from '../views/Uploader.vue'

import guest from "@/middlewares/guest";
import auth from "@/middlewares/auth";

const routes: Array<any> = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: 'home_page.browser_title',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'login_page.browser_title',
      middleware: [
        guest,
      ],
    },
  },
  {
    path: '/sign-up',
    name: 'sign_up',
    component: SignUp,
    meta: {
      title: 'signup_page.browser_title',
      middleware: [
        guest,
      ],
    },
  },
  {
    path: '/create-event',
    name: 'create_event',
    component: CreateEvent,
    meta: {
      title: 'create_event_page.browser_title',
      middleware: [
        auth,
      ],
    },
  },
  {
    path: '/events',
    name: 'event_list',
    component: EventList,
    meta: {
      title: 'event_list_page.browser_title',
      middleware: [
        auth,
      ],
    },
  },
  {
    path: '/exercise-voice',
    name: 'exercise_voice',
    component: ExerciseVoice,
    meta: {
      title: 'exercise_voice_page.browser_title',
      middleware: [
        auth,
      ],
    },
  },
  {
    path: '/transitions',
    name: 'transitions',
    component: Transitions,
    meta: {
      title: 'transitions_page.browser_title',
      middleware: [
        auth,
      ],
    },
  },
  {
    path: '/class-builder',
    name: 'class_builder',
    component: ClassBuilder,
    meta: {
      title: 'class_builder_page.browser_title',
      middleware: [
        auth,
      ],
    },
  },
  {
    path: '/uploader',
    name: 'uploader',
    component: Uploader,
    meta: {
      title: 'uploader_page.browser_title',
      middleware: [
        auth,
      ],
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next();
  }
  const {middleware} = to.meta;
  const context = {
    to,
    from,
    next,
  };
  return middleware[0]({
    ...context,
  });
});

Vue.use(VueRouter)

export default router
